module.exports = __webpack_public_path__ + "img/btn.703a353c.png";